// extracted by mini-css-extract-plugin
export var completionBody = "_gb-2";
export var completionCard = "_gb-0";
export var completionFooter = "_gb-3";
export var completionTitle = "_gb-1";